import React from "react";
import { useOurApi } from "../../../hooks/useOurApi"
import  Spinner  from "../../Spinner/Spinner"
import MensajeError from '../../Mensajes/MensajeError'
import SolicitudRepresentacion from "./SolicitudRepresentacion"
import SolicitudesRepresentacionPendientes from "./SolicitudesRepresentacionPendientes"
import SolicitudesRepresentacionRespondidas from "./SolicitudesRepresentacionRespondidas"
import FiltradoRepresentaciones from "../Filtrado/FiltradoRepresentaciones"

import { useEffect, useState, useContext } from "react";
import { AppContext } from '../../../App'

export default function DatosDeRepresentacionesCtrl(){
    
  const {state, dispatch} = useContext(AppContext);

  const url = `${process.env.REACT_APP_API_SISTEMAREPRESENTACIONES}/representaciones/v1/solicitudesRepresentacion/propias`;
  const { data, isLoading, hasError } = useOurApi(url, {});

  useEffect(() => {
    if(data && data.length > 0) {
      const listPendientes = data.filter((item) => item.estadoActual == 1);    
      //const listPendientesUI = data.filter((item) => item.estadoActual == 1);    
      dispatch({ type: 'UPDATE_SOLICITUDES_PENDIENTES_STATUS', data: JSON.parse(JSON.stringify(listPendientes)),});
      dispatch({ type: 'UPDATE_SOLICITUDES_PENDIENTES_UI_STATUS', data: JSON.parse(JSON.stringify(listPendientes)),});

      const listRespondidas = data.filter((item) => item.estadoActual == 2);
      //const listRespondidasUI = data.filter((item) => item.estadoActual == 2);    
      dispatch({ type: 'UPDATE_SOLICITUDES_RESPONDIDAS_STATUS', data: JSON.parse(JSON.stringify(listRespondidas)),});
      dispatch({ type: 'UPDATE_SOLICITUDES_RESPONDIDAS_UI_STATUS', data: JSON.parse(JSON.stringify(listRespondidas)),});

      const listBajas = data.filter((item) => item.estadoActual != 1 && item.estadoActual != 2);
      //const listBajasUI = data.filter((item) => item.estadoActual != 1 && item.estadoActual != 2);    
      dispatch({ type: 'UPDATE_SOLICITUDES_BAJAS_STATUS', data: JSON.parse(JSON.stringify(listBajas)),});
      dispatch({ type: 'UPDATE_SOLICITUDES_BAJAS_UI_STATUS', data: JSON.parse(JSON.stringify(listBajas)),});
    }
  }, [data])


  if (isLoading) return <Spinner />;

  if (hasError){
    const mensaje={data:"Fallo obteniendo datos de representaciones actuales. Póngase en contacto con el soporte (soportec@navarra.es) para resolver el problema."};
    return <MensajeError mensaje={mensaje} />;
  }
 
  
  return  <>
    
    <div className="our-grid">
      <SolicitudRepresentacion tipoSolicitudRepresentacion={'2'}></SolicitudRepresentacion>
      <br/>

      {state.nifNombreUsuario != '' && !state.nifNombreUsuario.toUpperCase().startsWith("E") && !state.nifNombreUsuario.toUpperCase().startsWith("H") && !state.nifNombreUsuario.toUpperCase().startsWith("U") &&
        <>
        <SolicitudRepresentacion tipoSolicitudRepresentacion={'1'}></SolicitudRepresentacion>
        <br/>            
        </>
      }      

      <FiltradoRepresentaciones></FiltradoRepresentaciones>
      <br/>
      
      <SolicitudesRepresentacionPendientes></SolicitudesRepresentacionPendientes>
      <br/>
      
      <SolicitudesRepresentacionRespondidas tipoRepresentacionRespondida={'Vigente'}></SolicitudesRepresentacionRespondidas>
      <br/>
      
      <SolicitudesRepresentacionRespondidas tipoRepresentacionRespondida={'Baja'}></SolicitudesRepresentacionRespondidas>

    </div>
    </>
}